export default "__VITE_ASSET__CxNZ$lvv__"